import React from 'react'
import PropTypes from 'prop-types'

import DisclosureModal from 'multi-vertical/rate-table/components/disclosure-modal'
import refiDisclaimers from 'student-loan-refi/rate-table/lender/disclaimers'
import slDisclaimers from 'student-loan/rate-table/lender/disclaimers'
import { fireGtmEvent } from 'utils/gtm'
import { PartnerLogo } from 'components/partner-logo'
import CtaButton from 'components/cta-button'

import styles from './styles.module.scss'
import { scrollToIframeTop } from '../../../utils'

const onCtaClicked = (lenderName, widgetContext) => () => {
  const lender = { lender: lenderName }

  fireGtmEvent('ctaClick', Object.assign(lender, widgetContext))
}
const getDisclaimersData = (name) =>
  name === 'multiVerticalRefi' ? refiDisclaimers : slDisclaimers

const LenderTile = ({
  lender: { rateSlug, name, slug, minFixedRate, maxFixedRate, minVariableRate, maxVariableRate },
  tileName,
  ctaUrl,
  widgetContext,
}) => {
  const disclaimers = getDisclaimersData(tileName)

  return (
    <div data-test-id={`rateTableTile_${rateSlug}`} className={`${styles.lenderSection} mt-8`}>
      <div className={styles.logo}>
        <PartnerLogo partner={slug} className={slug} />
        {!!disclaimers[slug] && (
          <DisclosureModal
            name={name}
            title="Disclaimer"
            onOpenModalHandler={() => scrollToIframeTop()}
          >
            {disclaimers[slug]}
          </DisclosureModal>
        )}
      </div>
      <div className={styles.rateFixed}>
        <p className={`${styles.subtitle} disclaimer mb-0 mb-sm-8`}>Fixed APR from</p>
        <p className={`${styles.number} semiBold`}>
          {minFixedRate}% - {maxFixedRate}%
        </p>
      </div>
      <div className={styles.rateVar}>
        {minVariableRate && (
          <>
            <p className={`${styles.subtitle} disclaimer mb-0 mb-sm-8`}>Variable APR from</p>
            <p className={`${styles.number} semiBold`}>
              {minVariableRate}% - {maxVariableRate}%
            </p>
          </>
        )}
      </div>
      <div className={styles.ctaSection}>
        <CtaButton
          data-testid="cta-button"
          href={ctaUrl}
          target="_blank"
          onClick={onCtaClicked(name, widgetContext)}
          size="small"
        >
          Check Rates
        </CtaButton>
        <p className={`${styles.texts} disclaimer mt-8 align-center hidden-xs`}>
          on Credible's website
        </p>
      </div>
    </div>
  )
}

LenderTile.propTypes = {
  tileName: PropTypes.string,
  lender: PropTypes.object,
  ctaUrl: PropTypes.string,
  widgetContext: PropTypes.object,
}

export { LenderTile, getDisclaimersData, onCtaClicked }

export default LenderTile
